import * as React from 'react';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { TabBackupsHOC } from '../../hocs/TabBackupsHOC/TabBackupsHOC';

export function TabBackupsContext() {
    const { boardId } = React.useContext(AsidePanelContext);
    return <TabBackupsHOC boardId={boardId}/>
}
